import { Component, OnInit } from '@angular/core';
import { Company } from '../../classes/company';
import { CompanyService } from '../../services/company.service';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-add-company-page',
  templateUrl: './add-company-page.component.html',
  styleUrls: ['./add-company-page.component.scss']
})
export class AddCompanyPageComponent implements OnInit {

  company: Company = <Company>{};
  name: string = '';
  companies: Company[] = [];
  sub: any;
  orgId: number;

  constructor(private CompanyService: CompanyService, private router: Router, private route: ActivatedRoute, private titleService: Title) { }

  ngOnInit() {

    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      this.getCompanies();
    });

    this.titleService.setTitle('Add Company');
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getCompanies() {
    this.CompanyService.getCompanies()
      .subscribe(companies => {
        console.log(companies)
        this.companies = JSON.parse(companies.organizations).map((c) => {
          return {
            name: c.name,
            id: c.id
          }
        })
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  addCompany(companyForm: NgForm) {
    if (companyForm.invalid) {
      return;
    }
    this.CompanyService.addCompany(this.company)
      .subscribe(companies => {
        this.getCompanies();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })

  }

  removeCompany(id: number) {
    this.CompanyService.deleteCompany(id)
      .subscribe(companies => {
        this.getCompanies();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/add-company-page/add-company-page.component.ts